import { useCallback, useState } from 'react'
import type { ClaudeSession } from '@/features/events/conversation/state/types'
import { buildSessionTerminatePayload, commandClient } from '../api'

interface UseTerminateSessionReturn {
  readonly terminateSession: (session: ClaudeSession) => Promise<boolean>
  readonly isSubmitting: boolean
}

export function useTerminateSession(): UseTerminateSessionReturn {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const terminateSession = useCallback(async (session: ClaudeSession): Promise<boolean> => {
    setIsSubmitting(true)

    try {
      const payload = buildSessionTerminatePayload(session)
      const result = await commandClient.submit(payload)

      if (!result.success) {
        throw new Error(result.message)
      }

      return true
    } finally {
      setIsSubmitting(false)
    }
  }, [])

  return { terminateSession, isSubmitting }
}
